import {type FunctionalComponent, h} from '@stencil/core';


export interface FacetsPane {

    shouldShowFacetBar: boolean
    isDashboardView: boolean
    horizontalFilterPanel: boolean
    filterPane: CallableFunction
}

export const FacetsPane: FunctionalComponent<FacetsPane> = (props) => {

    const {shouldShowFacetBar, isDashboardView, horizontalFilterPanel, filterPane } = props;

    return (
      shouldShowFacetBar ? (
        <div
          class={horizontalFilterPanel ? 'filters__section-horizontal' : 'filters__section'}>
          {filterPane()}
          <slot name="under-filters"/>
        </div>
      ) : (
        isDashboardView ? '' : <slot name="filters-placeholder"/>
      )
    );
};
